/* eslint-disable react/button-has-type */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@glu/theming';

const VARIANTS = ['primary', 'secondary'];

const styles = ({ buttons }) => ({
  root: ({ variant }) => {
    switch (variant) {
      case 'secondary':
        return {
          ...buttons.secondary,
          textAlign: 'center'
        };
      case 'primary':
      default:
        return {
          ...buttons.primary,
          textAlign: 'center',
          textTransform: 'uppercase'
        };
    }
  }
});

const Button = ({
  classes,
  className,
  children,
  type,
  variant: _variant,
  theme: _theme,
  ...props
}) => {
  const classNames = `${classes.root} ${className}`;
  return (
    <button type={type} className={classNames} {...props}>
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  theme: PropTypes.shape({}).isRequired,
  type: PropTypes.string,
  variant: PropTypes.oneOf(VARIANTS),
  className: PropTypes.string
};

Button.defaultProps = {
  variant: 'primary',
  type: 'button',
  className: ''
};

export default withStyles(styles)(Button);
